import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PromptDialogOnSide } from 'common/components/PromptDialogOnSide/PromptDialogOnSide';
import { styles } from 'common/components/PromptDialogOnSide/PromptDialogOnSide.styles';
import { FormInput } from 'common/form/components/FormInput';
import { transformNaNtoNull } from 'common/form/validators';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

interface FormValues {
  amount?: number | null;
}

export interface EditFinancialReserveAmountDialogProps extends DialogComponentProps<number | undefined | null> {
  amount?: number | null;
}

export const EditFinancialReserveAmountDialog: React.FC<EditFinancialReserveAmountDialogProps> = ({
  amount,
  isOpen,
  onReject,
  onResolve,
}) => {
  const { t } = useTranslation();

  const schema: yup.SchemaOf<FormValues> = yup.object({
    amount: yup
      .number()
      .transform(transformNaNtoNull)
      .nullable(false)
      .moreThan(0, t('form.validator.moreThan', { value: 0 })),
  });

  const formMethods = useForm<FormValues>({
    defaultValues: {
      amount,
    } as FormValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const handleSubmit = formMethods.handleSubmit(async (data) => {
    onResolve(data.amount);
  });

  return (
    <PromptDialogOnSide
      onClose={() => onReject()}
      open={isOpen}
      title={t('fintelligenceReport.editFinancialReserveAmountDialog.title')}
    >
      <FormProvider {...formMethods}>
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Box>
            <FormInput
              InputProps={{
                endAdornment: (
                  <Typography color="textSecondary" variant="bodyL">
                    {t('common:inputEndAdornment.eur')}
                  </Typography>
                ),
              }}
              autoFocus
              name="amount"
              type="number"
            />
          </Box>

          <Stack mt={3} spacing={1}>
            <Button color="primary" sx={styles.button} type="submit">
              <Typography color="white" variant="bodyL">
                {t('fintelligenceReport.editFinancialReserveAmountDialog.save')}
              </Typography>
            </Button>
            <Button color="tertiaryButton" onClick={() => onReject()} sx={styles.button}>
              <Typography color="blue.dark" variant="bodyL">
                {t('common:cancel')}
              </Typography>
            </Button>
          </Stack>
        </Box>
      </FormProvider>
    </PromptDialogOnSide>
  );
};
